import Component from './applicant_random_dialog.vue'
export default Component
